<template>
  <div id="add-manufacture">
    <base-header class="bg-primary pb-6 pt-0">
      <div class="row align-items-center pb-2">
        <div class="col-lg-6 col-7">
          <breadcrumb :link="[{ name: 'Tạo mới lệnh chế tạo', active: true }]"></breadcrumb>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6 bg-lighter pb-5">
      <block :nobody="true" ref="bmanufacture" class="soft-control">
        <!-- <b-row align-v="center" class="text-center">
          <b-col><h3 class="mt-3">Báo giá mới</h3></b-col>
        </b-row>
        <hr /> -->
        <b-row class="mx-0" align-h="center">
          <b-col md="10 px-0 border-right border-info">
            <b-card class="m-3">
              <ValidationObserver ref="csInfo" v-slot="{ handleSubmit }">
                <form role="form" @submit.prevent="handleSubmit(doSave)">
                  <b-row>
                    <b-col>
                      <base-input
                        :disabled="manufacture.id != ''"
                        v-model="manufacture.code"
                        label="Mã lệnh chế tạo"
                        placeholder="Không nhập hệ thống sẽ tự phát sinh"
                      >
                      </base-input>
                    </b-col>
                    <b-col>
                      <div>
                        <label for="datepicker-lg">Ngày tạo</label>
                        <b-form-datepicker
                          :disabled="true"
                          id="datepicker-lg"
                          :date-format-options="{
                            year: 'numeric',
                            month: '2-digit',
                            day: '2-digit'
                          }"
                          v-model="manufacture.date"
                          locale="vi"
                        ></b-form-datepicker>
                      </div>
                    </b-col>
                    <b-col>
                      <div>
                        <label for="datepicker-delivery">Ngày giao hàng</label>
                        <b-form-datepicker
                          :disabled="true"
                          id="datepicker-lg"
                          :date-format-options="{
                            year: 'numeric',
                            month: '2-digit',
                            day: '2-digit'
                          }"
                          v-model="manufacture.dateDelivery"
                          locale="vi"
                        ></b-form-datepicker>
                      </div>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col md="4">
                      <ValidationProvider rules="required" v-slot="{ errors }">
                        <base-select
                          :disabled="manufacture.id != ''"
                          v-model="manufacture.customer"
                          label="Mã khách hàng"
                          :ajaxData="getCustomer"
                          :error="errors[0]"
                        >
                          <template v-slot:selected="{ item }">
                            <div>
                              {{ item.code }}
                            </div>
                          </template>
                          <template v-slot:body="{ item }">
                            <div>
                              <strong>{{ item.code }}</strong> <br />
                              <span>{{ item.name }}</span>
                            </div>
                          </template>
                        </base-select>
                      </ValidationProvider>
                    </b-col>
                    <!-- <b-col md="4">
                      <base-select
                        :disabled="manufacture.id != ''"
                        v-model="manufacture.customer"
                        label="Tên khách hàng"
                        :ajaxData="getCustomer"
                        ><template v-slot:selected="{ item }">
                          <div>
                            {{ item.name }}
                          </div>
                        </template>
                        <template v-slot:body="{ item }">
                          <div>
                            <strong>{{ item.code }}</strong> <br />
                            <span>{{ item.name }}</span>
                          </div>
                        </template>
                      </base-select>
                    </b-col>
                    <b-col md="4">
                      <base-select
                        :disabled="manufacture.id != ''"
                        v-model="manufacture.customer"
                        label="Email khách hàng"
                        :ajaxData="getCustomer"
                        ><template v-slot:selected="{ item }">
                          <div>
                            {{ item.email }}
                          </div>
                        </template>
                        <template v-slot:body="{ item }">
                          <div>
                            <strong>{{ item.code }}</strong> <br />
                            <span>{{ item.name }}</span>
                          </div>
                        </template>
                      </base-select>
                    </b-col> -->
                    <b-col md="4">
                      <ValidationProvider rules="required" v-slot="{ errors }">
                        <base-select
                          :disabled="manufacture.id != ''"
                          @change="productChange"
                          v-model="manufacture.product"
                          :ajaxData="getProduct"
                          label="Mã sản phẩm"
                          :error="errors[0]"
                        >
                          <template v-slot:selected="{ item }">
                            <div>
                              {{ item.code }}
                            </div>
                          </template>
                          <template v-slot:body="{ item }">
                            <div>
                              <strong>{{ item.code }}</strong> <br />
                              <span>{{ item.name }}</span>
                            </div>
                          </template>
                        </base-select>
                      </ValidationProvider>
                    </b-col>
                    <b-col md="4">
                      <div class="form-group base-select has-label">
                        <label class="form-control-label">
                          Tên sản phẩm:
                        </label>
                        <div class="selection form-control p-1">
                          {{ manufacture.product.name }}
                          <!-- <div v-if="manufacture.productCustom && manufacture.productCustom.length > 0">
                            <hr class="m-0" />
                            <i>{{ manufacture.productCustom }}</i>
                          </div> -->
                          <div v-if="manufacture.reason">
                            <hr class="m-0" />
                            <i>{{ manufacture.reason.name }}</i>
                          </div>
                        </div>
                      </div>
                    </b-col>
                  </b-row>
                  <hr />
                  <span> Đặt thù khách hàng : {{ manufacture.customer.fax }} </span>
                  <hr />
                  <div v-if="manufacture.reason">
                    <span> Diễn giải : {{ manufacture.reason.name }} </span>
                    <hr />
                  </div>
                  <b-row>
                    <b-col md="3">
                      <base-select
                        label="Quy cách"
                        :disabled="manufacture.id != ''"
                        @change="productSpecifyChange"
                        v-if="manufacture.product && manufacture.product.id"
                        v-model="manufacture.productSpecify"
                        :options="manufacture.product.productSpecifys"
                        :error="!manufacture.productSpecify || !manufacture.productSpecify.id"
                      >
                        <template v-slot:selected="{ item }">
                          <div>{{ item.id }} -</div>
                          <div>{{ item.name }} mm</div>
                          <span v-if="item.color && item.color.id"> - {{ item.color.label }} </span>
                        </template>
                        <template v-slot:body="{ item }">
                          <div>
                            <strong>{{ item.code }}</strong> <br />
                            <span>{{ item.name }} mm</span>
                            <span v-if="item.color && item.color.id"> - {{ item.color.label }} </span>
                          </div>
                        </template>
                      </base-select>
                      <base-input
                        v-else
                        :disabled="!manufacture.product || !manufacture.product.id"
                        placeholder="Vui lòng chọn sản phẩm"
                        label="Quy cách"
                      >
                      </base-input>
                    </b-col>
                    <b-col md="3">
                      <ValidationProvider rules="required" v-slot="{ errors }">
                        <color
                          @change="loadInfoProduct"
                          :disabled="manufacture.id != ''"
                          v-model="manufacture.color"
                          label="Hệ màu"
                          :error="errors[0]"
                        ></color>
                      </ValidationProvider>
                    </b-col>
                    <b-col md="3">
                      <base-input
                        :disabled="manufacture.id != ''"
                        label="Màu sắc"
                        v-model="manufacture.colorText"
                      ></base-input>
                    </b-col>
                    <b-col md="3">
                      <base-input
                        :disabled="manufacture.id != ''"
                        label="Chiều dài (cm)"
                        v-model="manufacture.length"
                      ></base-input>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col md="3">
                      <base-input
                        label="Mã màu 1"
                        :disabled="manufacture.id != ''"
                        v-model="manufacture.colorCode1"
                      ></base-input>
                    </b-col>
                    <b-col md="3">
                      <base-input
                        label="Mã màu 2"
                        :disabled="manufacture.id != ''"
                        v-model="manufacture.colorCode2"
                      ></base-input>
                    </b-col>
                    <b-col md="3">
                      <base-input
                        :mask="'number'"
                        label="Định mức"
                        :disabled="manufacture.id != ''"
                        v-model="manufacture.quota"
                      ></base-input>
                    </b-col>
                    <b-col md="3">
                      <base-input
                        :disabled="manufacture.id != ''"
                        label="Co giãn"
                        v-model="manufacture.elastic"
                      ></base-input>
                    </b-col>
                  </b-row>
                  <b-row class="mt-2">
                    <b-col md="2">
                      <base-input :disabled="manufacture.id != ''" label="ĐVT" v-model="manufacture.unit"></base-input>
                    </b-col>
                    <b-col md="3">
                      <base-input
                        :label="`Số lượng đặt - (ĐVT : ${manufacture.unit})`"
                        :mask="'number'"
                        :disabled="manufacture.id != ''"
                        v-model="manufacture.quantityOrder"
                      ></base-input>
                    </b-col>
                    <b-col md="3">
                      <base-input
                        :label="`Số lượng tồn -(ĐVT : ${manufacture.unit})`"
                        :mask="'number'"
                        :disabled="manufacture.id != ''"
                        v-model="info.quantity"
                      ></base-input>
                    </b-col>
                    <b-col md="4">
                      <base-input
                        :label="`Số lượng dệt -(ĐVT : M) - (Đang dệt : ${quantityInventoried})`"
                        :disabled="manufacture.id != '' && $route.query.edit_id == ''"
                        :valid="manufacture.quantityInventory + quantityInventoried <= manufacture.quantityOrder"
                        :mask="'number'"
                        v-model="manufacture.quantityInventory"
                      ></base-input>
                    </b-col>
                  </b-row>
                </form>
              </ValidationObserver>

              <hr />
              <div>
                <h5>* Độ khó :</h5>
                <table class="table table-bordered" style="width:300px">
                  <tr>
                    <td>Rất khó</td>
                    <td>Khó</td>
                    <td>Bình thường</td>
                  </tr>
                  <tr>
                    <td>
                      <div class="form-check">
                        <input class="" name="level" v-model="manufacture.level" type="radio" value="3" />
                      </div>
                    </td>
                    <td>
                      <div class="form-check">
                        <input class="" name="level" v-model="manufacture.level" type="radio" value="1" />
                      </div>
                    </td>
                    <td>
                      <div class="form-check">
                        <input class="" name="level" v-model="manufacture.level" type="radio" value="2" />
                      </div>
                    </td>
                  </tr>
                </table>

                <h5>* Quy trình sản xuất :</h5>
                <div class="table-responsive">
                  <table class="table table-bordered">
                    <tr>
                      <td>Cone chỉ</td>
                      <td>Đánh trục</td>
                      <td>Dệt</td>
                      <td>Quấn bó/ống</td>
                      <td style="width:70px"></td>
                      <td>Định hình dây</td>
                      <td>Cắt</td>
                      <td>Công đoạn mặt dây</td>
                      <td>Công đoạn đầu dây</td>
                      <td>Kiểm phẩm</td>
                      <td>Nhập kho</td>
                    </tr>
                    <tr>
                      <td>
                        <div class="form-check">
                          <input
                            class=""
                            name="process"
                            v-model="manufacture.process.cone_chi"
                            type="checkbox"
                            value="true"
                          />
                        </div>
                      </td>
                      <td>
                        <div class="form-check">
                          <input
                            class=""
                            name="process"
                            v-model="manufacture.process.danh_truc"
                            type="checkbox"
                            value="true"
                          />
                        </div>
                      </td>
                      <td>
                        <div class="form-check">
                          <input
                            class=""
                            name="process"
                            v-model="manufacture.process.det"
                            type="checkbox"
                            value="true"
                          />
                        </div>
                      </td>
                      <td>
                        <div class="form-check">
                          <input
                            class=""
                            name="process"
                            v-model="manufacture.process.quan_bo"
                            type="checkbox"
                            value="true"
                          />
                        </div>
                      </td>
                      <td>
                        <div class="form-check">
                          <input
                            class=""
                            name="process"
                            v-model="manufacture.process.nhuom_sau"
                            type="checkbox"
                            value="true"
                          />
                        </div>
                      </td>
                      <td>
                        <div class="form-check">
                          <input
                            class=""
                            name="process"
                            v-model="manufacture.process.can_nhiet_ho"
                            type="checkbox"
                            value="true"
                          />
                        </div>
                      </td>
                      <td>
                        <div class="form-check">
                          <input
                            class=""
                            name="process"
                            v-model="manufacture.process.cat"
                            type="checkbox"
                            value="true"
                          />
                        </div>
                      </td>
                      <td>
                        <div class="form-check">
                          <input
                            class=""
                            name="process"
                            v-model="manufacture.process.bam_dau_keo"
                            type="checkbox"
                            value="true"
                          />
                        </div>
                      </td>
                      <td>
                        <div class="form-check">
                          <input
                            class=""
                            name="process"
                            v-model="manufacture.process.bam_dau_dong"
                            type="checkbox"
                            value="true"
                          />
                        </div>
                      </td>
                      <td>
                        <div class="form-check">
                          <input
                            class=""
                            name="process"
                            v-model="manufacture.process.kiem_pham"
                            type="checkbox"
                            value="true"
                          />
                        </div>
                      </td>
                      <td>
                        <div class="form-check">
                          <input
                            class=""
                            name="process"
                            v-model="manufacture.process.nhap_kho"
                            type="checkbox"
                            value="true"
                          />
                        </div>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
              <hr />
              <div class="d-flex">
                <h5>* Thông số :</h5>
                <b-button @click="featureProductAddRow" variant="success px-1 py-0 ml-2 mb-2">
                  <i class="fa fa-flus" aria-hidden="true"></i> Thêm 1 dòng
                </b-button>
              </div>
              <base-table :data="productFeatures">
                <template slot="columns">
                  <th>STT</th>
                  <th>Công dụng</th>
                  <th>Nguyên liệu</th>
                  <th>Quy cách</th>
                  <th>Màu sắc</th>
                  <th>Mã màu 1</th>
                  <th>Mã màu 2</th>
                  <th>Số lượng</th>
                  <th>% Sợi</th>
                  <th>Trọng lượng kg</th>
                  <th>% Hao hụt</th>
                  <th>Tổng trọng lượng kg</th>
                  <th>Trọng lượng đặt hàng</th>
                  <th></th>
                </template>

                <template slot-scope="{ row, index }">
                  <tr v-if="!row.edit" :key="index">
                    <td class="bg-info text-light col-fix ">
                      {{ index + 1 }}
                    </td>
                    <td>{{ row.deportment }}</td>
                    <td class="text-center">{{ row.material }}</td>
                    <td class="text-center">{{ row.spec }}</td>
                    <td class="text-center">{{ row.color.label }}</td>
                    <td class="text-center">{{ row.colorCode1 }}</td>
                    <td class="text-center">{{ row.colorCode2 }}</td>
                    <td class="text-center">
                      {{ row.quantity }}
                    </td>
                    <td class="text-right">{{ $formatNumber(row.percentYarn) }} %</td>
                    <td class="text-right">{{ $formatNumber(row.weight) }} kg</td>
                    <td class="text-right">{{ $formatNumber(row.percentLoss) }} %</td>
                    <td class="text-right">{{ $formatNumber(row.total_weight) }} kg</td>
                    <td class="text-right text-red">{{ $formatNumber(row.tldh) }} kg</td>
                  </tr>
                  <tr v-else :key="'m' + index">
                    <td class="bg-info text-light col-fix text-center">
                      {{ index + 1 }}
                    </td>
                    <td style="min-width:160px">
                      <base-input v-model="row.deportment"></base-input>
                    </td>
                    <td>
                      <base-input v-model="row.material"></base-input>
                    </td>
                    <td style="min-width:100px">
                      <base-input v-model="row.spec"></base-input>
                    </td>
                    <td style="min-width:100px">
                      <color :error="!row.color || !row.color.id" v-model="row.color"></color>
                    </td>
                    <td style="min-width:100px">
                      <base-input v-model="row.colorCode1"></base-input>
                    </td>
                    <td style="min-width:100px">
                      <base-input v-model="row.colorCode2"></base-input>
                    </td>
                    <td style="min-width:120px">
                      <base-input v-model="row.quantity"></base-input>
                    </td>
                    <td style="min-width:120px">
                      <base-input @change="calcWeigth(row)" :mask="'number'" v-model="row.percentYarn"></base-input>
                    </td>
                    <td style="min-width:120px">
                      <base-input :mask="'number'" v-model="row.weight"></base-input>
                    </td>
                    <td style="min-width:120px">
                      <base-input @change="calcWeigth(row)" :mask="'number'" v-model="row.percentLoss"></base-input>
                    </td>
                    <td style="min-width:120px">
                      <base-input :mask="'number'" v-model="row.total_weight"></base-input>
                    </td>
                    <td style="min-width:120px;" class="text-red">
                      <base-input :mask="'number'" v-model="row.tldh"></base-input>
                    </td>
                    <td>
                      <b-button
                        class="mr-2"
                        variant="outline-danger px-1 py-0"
                        @click="productFeatureDeleteRow(index, row)"
                      >
                        <i class="fa fa-backspace" aria-hidden="true"></i>
                      </b-button>
                    </td>
                  </tr>
                </template>
                <template slot="tfoot">
                  <tr>
                    <th colspan="7">Tổng cộng</th>
                    <th colspan="2" style="text-align:right">{{ $formatNumber(summary.percentYarn) }} %</th>
                    <th style="text-align:right">{{ $formatNumber(summary.weight) }} Kg</th>
                    <th></th>
                    <th style="text-align:right">{{ $formatNumber(summary.total_weight) }} Kg</th>
                    <th style="text-align:right">{{ $formatNumber(summary.tldh) }} Kg</th>
                  </tr>
                </template>
              </base-table>
              <div class="d-flex  mt-3">
                <h5>* Ghi chú :</h5>
                <b-button @click="productParameterAddRow" variant="success px-1 py-0 ml-2 mb-2">
                  <i class="fa fa-flus" aria-hidden="true"></i> Thêm 1 dòng
                </b-button>
              </div>
              <table class="table">
                <template v-for="(item, index) in productParameters">
                  <tr v-if="item.edit" :key="index">
                    <td>
                      <ckeditor :editor="editor" v-model="item.col1" @ready="onReady" :config="editorConfig"></ckeditor>
                      <!-- <base-input v-model="item.col1"></base-input> -->
                    </td>
                    <!-- <td>
                      <base-input v-model="item.col2"></base-input>
                    </td>
                    <td>
                      <base-input v-model="item.col3"></base-input>
                    </td>
                    <td>
                      <base-input v-model="item.col4"></base-input>
                    </td> -->
                    <td>
                      <b-button
                        class="mr-2"
                        variant="outline-danger px-1 py-0"
                        @click="productParameterDeleteRow(index, item)"
                      >
                        <i class="fa fa-backspace" aria-hidden="true"></i>
                      </b-button>
                    </td>
                  </tr>
                  <tr v-else :key="'k' + index">
                    <td>
                      <div v-html="item.col1"></div>
                    </td>
                    <!-- <td>{{ index + 1 }} /</td>
                    <td>{{ item.col1 }}</td>
                    <td>{{ item.col2 }}</td>
                    <td>{{ item.col3 }}</td>
                    <td>{{ item.col4 }}</td> -->
                  </tr>
                </template>
              </table>
              <!-- <hr />
              <div class="form-group" style="overflow: hidden;">
                <label class="form-control-label" for="">Bỗ sung</label>
                <ckeditor
                  :editor="editor"
                  v-model="manufacture.note"
                  @ready="onReady"
                  :config="editorConfig"
                ></ckeditor>
              </div> -->
            </b-card>
          </b-col>
          <b-col md="2 px-0">
            <b-card class="m-3 sticky-top">
              <b-row>
                <b-col xl="12" class="mb-2">
                  <b-button @click="handleSave" variant="success" block>
                    <i class="fa fa-save" aria-hidden="true"></i>
                    {{
                      manufacture.id != '' && $route.query.edit_id == '' ? 'Đã Lưu lệnh chế tạo' : 'Lưu lệnh chế tạo'
                    }}
                  </b-button>
                </b-col>
                <b-col xl="12" class="mb-2">
                  <b-button :disabled="!manufacture.id" @click="doPrint" variant="primary" block>
                    <i class="fa fa-print" aria-hidden="true"></i>
                    In lệnh chế tạo
                  </b-button>
                </b-col>
                <b-col xl="12">
                  <b-button @click="doBack" block>
                    <i class="fa fa-long-arrow-alt-left" aria-hidden="true"></i>
                    Trở về
                  </b-button>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>
        <preview @doSave="handleSaveFromPreview" ref="preview"></preview>
      </block>
    </div>
  </div>
</template>
<script>
import { orderService, customerService, productService, manufactureService, colorService } from '@/_services';
import CKEditor from '@ckeditor/ckeditor5-vue';
import ClassicEditor from '@ckeditor/ckeditor5-build-decoupled-document';
import Preview from './__Preview';

export default {
  name: 'add-manufacture',
  components: {
    ckeditor: CKEditor.component,
    Preview
  },
  data() {
    return {
      countChecked: 0,
      listQuery: {
        page: 1,
        limit: 30,
        total: 0
      },
      manufacture: {
        id: '',
        code: '',
        product: '',
        productSpecify: '',
        quota: 0,
        level: 1,
        processJson: '',
        process: {
          cone_chi: false,
          danh_truc: true,
          det: true,
          quan_bo: false,
          nhuom_sau: false,
          can_nhiet_ho: false,
          cat: false,
          bam_dau_keo: false,
          bam_dau_dong: false,
          kiem_pham: true,
          nhap_kho: true
        },
        customer: '',
        quantityOrder: 0,
        quantityProduce: 0,
        quantityInventory: 0,
        color: '',
        colorText: '',
        order: {},
        orderDetail: {},
        dateDelivery: new Date(),
        date: new Date(),
        colorCode1: '',
        elastic: '',
        colorCode2: '',
        mKg: 0,
        yKg: 0,
        note: '<ul><li>Tổng số chỉ chia <b> 4 </b> dây</li></ul>'
      },
      summary: {
        percentYarn: 0,
        weight: 0,
        total_weight: 0
      },
      quantityInventoried: 0,
      info: {},
      productFeatures: [],
      productParameters: [],
      editor: ClassicEditor,
      editorConfig: {
        toolbar: [
          'heading',
          '|',
          'fontSize',
          'fontFamily',
          'fontColor',
          'fontBackgroundColor',
          '|',
          'bold',
          'italic',
          'link',
          'underline',
          'strikethrough',
          '|',
          'alignment',
          'bulletedList',
          'numberedList',
          'blockQuote',
          '|',
          'indent',
          'outdent',
          'link',
          'insertTable',
          'tableColumn',
          'tableRow',
          'mergeTableCells'
        ]
      },
      back: -1
    };
  },
  mounted() {
    var self = this;
    if (this.$route.query.order) {
      orderService.findOne(this.$route.query.order).then(res => {
        let order = res.data;
        self.manufacture.order = order;
        let orderDetails = order.orderDetails;
        self.manufacture.customer = order.customer;
        self.manufacture.note = order.note + '<ul><li>Tổng số chỉ chia <b> 4 </b> dây</li></ul>';
        self.manufacture.dateDelivery = new Date(order.dateDelivery);

        for (let i = 0; i < orderDetails.length; i++) {
          const element = orderDetails[i];
          if (element.id == self.$route.query.order_detail) {
            self.manufacture.product = element.product;
            self.manufacture.reason = element.reason;
            self.manufacture.reasonId = element.reasonId;
            self.manufacture.productCustom = element.productCustom;
            self.manufacture.productSpecify = element.productSpecify;
            self.manufacture.quantityOrder = element.quantity;
            self.manufacture.color = element.color;
            self.manufacture.colorText = element.colorText;
            self.manufacture.colorCode1 = element.colorCode;
            self.manufacture.colorCode2 = element.colorCode2;
            self.manufacture.unit = element.unit;
            self.manufacture.length = element.length;
            self.manufacture.elastic = element.productSpecify.elastic;
            self.manufacture.orderDetail = element;

            self.productSpecifyChange();
            self.findWithProduct(order.id, element.id, element.product.id, element.productSpecify.id, element.color.id);
            break;
          }
        }
        console.log(res.data);
      });
      // let product = productService.findOne(this.$route.query.product)
      // .then((res)=>{
      //     this.manufacture.product = res.data;
      // });
      // let productSpecify = productService.findSpec(this.$route.query.productSpecify)
      // .then((res)=>{
      //     this.manufacture.productSpecify = res.data;
      // });
    }
    if (this.$route.query.edit_id) {
      manufactureService.findOne(this.$route.query.edit_id).then(res => {
        self.manufacture = res.data;
        this.loadInfoProduct();
        try {
          self.manufacture.process = JSON.parse(self.manufacture.processJson);
        } catch (error) {
          self.manufacture.process = {
            cone_chi: false,
            danh_truc: true,
            det: true,
            quan_bo: false,
            nhuom_sau: false,
            can_nhiet_ho: false,
            cat: false,
            bam_dau_keo: false,
            bam_dau_dong: false,
            kiem_pham: true,
            nhap_kho: true
          };
        }

        delete self.manufacture.userVerify;
        self.productFeatures = self.manufacture.manufactureFeatures;
        self.productFeatures.forEach(element => {
          element.color = self.manufacture.color;
          element.colorCode1 = self.manufacture.colorCode1;
          element.colorCode2 = self.manufacture.colorCode2;
          element.edit = true;
          this.calcWeigth(element);
        });

        self.productParameters = self.manufacture.manufactureParameters;
        self.productParameters.forEach(element => {
          element.edit = true;
        });
        this.summaryFeature();
      });
    }
  },
  methods: {
    //tìm số lượng đang dệt
    findWithProduct(orderId, orderDetailId, productId, productSpecifyId, colorId) {
      manufactureService.findWidthProduct(orderId, orderDetailId, productId, productSpecifyId, colorId).then(res => {
        let histories = res.data;
        this.quantityInventoried = 0;
        for (let i = 0; i < histories.length; i++) {
          const element = histories[i];
          this.quantityInventoried += Number(element.quantityInventory);
        }
        //manufacture.quantityInventory + quantityInventoried <= manufacture.quantityOrder
        if (this.quantityInventoried < this.manufacture.quantityOrder) {
          this.manufacture.quantityInventory = this.manufacture.quantityOrder - this.quantityInventoried;
        }
      });
    },
    getColor(keyword, cb) {
      colorService.findAll({ search: keyword }).then(res => {
        cb(res.data);
      });
    },
    getCustomer(keyword, cb) {
      customerService.findAll({ search: keyword }).then(res => {
        cb(res.data.data);
      });
    },
    getProduct(keyword, cb) {
      productService.findAll({ search: keyword }).then(res => {
        cb(res.data.data);
      });
    },
    onReady(editor) {
      // Insert the toolbar before the editable area.
      editor.ui
        .getEditableElement()
        .parentElement.insertBefore(editor.ui.view.toolbar.element, editor.ui.getEditableElement());
    },
    validateManufacture() {
      var self = this;
      return new Promise(async (resolve, reject) => {
        let validate = await self.$refs.csInfo.validate();
        if (validate) {
          resolve();
        } else {
          reject();
        }
      });
    },
    async handleSave() {
      await this.validateManufacture()
        .then(async () => {
          await this.doSave();
        })
        .catch(e => {
          this.$alertify.error('Vui lòng hoàn thành các trường được khoanh đỏ', {
            duration: 4000
          });
        });
    },
    async handleSaveFromPreview(cb) {
      await this.validateManufacture()
        .then(async () => {
          await this.doSave();
          cb();
        })
        .catch(e => {
          cb();
          this.$alertify.error('Vui lòng hoàn thành các trường được khoanh đỏ', {
            duration: 4000
          });
        });
    },
    featureProductAddRow() {
      this.productFeatures.push({
        edit: true,
        deportment: 'Sợi võ nền',
        material: 'poly',
        spec: '150/1',
        color: 'Đen',
        colorCode1: 'string',
        colorCode2: 'string',
        quantity: 2,
        percentYarn: 44.99,
        weight: 1.47,
        percentLoss: 2,
        total_weight: 1.5
      });
    },
    productFeatureDeleteRow(index, item) {
      if (item.edit) {
        this.productFeatures.splice(index, 1);
      } else {
        this.$swal({
          title: 'Bạn có chắc thực hiện thao tác này?',
          text: 'Bạn sẽ không thể hoàn nguyên điều này!!',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'OK',
          cancelButtonText: 'Không',
          reverseButtons: true
        }).then(function(result) {
          if (result.value) {
            alert('contact dev');
          }
        });
      }
    },
    summaryFeature() {
      this.summary.percentYarn = 0;
      this.summary.weight = 0;
      this.summary.total_weight = 0;
      this.summary.tldh = 0;
      this.productFeatures.forEach(element => {
        this.summary.percentYarn += Number(element.percentYarn);
        this.summary.weight += Number(element.weight);
        this.summary.total_weight += Number(element.total_weight);
        this.summary.tldh += Number(element.tldh);
      });
    },
    productParameterAddRow() {
      this.productParameters.push({
        edit: true,
        col1: '',
        col2: '',
        col3: '',
        col4: ''
      });
    },
    productParameterDeleteRow(index, item) {
      if (item.edit) {
        this.productParameters.splice(index, 1);
      } else {
        this.$swal({
          title: 'Bạn có chắc thực hiện thao tác này?',
          text: 'Bạn sẽ không thể hoàn nguyên điều này!!',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'OK',
          cancelButtonText: 'Không',
          reverseButtons: true
        }).then(function(result) {
          if (result.value) {
            alert('contact dev');
          }
        });
      }
    },
    productChange() {
      this.manufacture.productSpecify = '';
    },
    productSpecifyChange() {
      this.loadInfoProduct();
      this.$refs.bmanufacture.block();
      productService
        .findSpec(this.manufacture.productSpecify.id)
        .then(res => {
          this.manufacture.quota = res.data.quota;
          let productParameters = res.data.productParameters;
          productParameters.forEach(element => {
            element.edit = true;
          });
          this.productParameters = productParameters;

          let productFeatures = res.data.productFeatures;
          var self = this;
          productFeatures.forEach(element => {
            element.edit = true;
            element.color = self.manufacture.color;
            element.colorCode1 = self.manufacture.colorCode1;
            element.colorCode2 = self.manufacture.colorCode2;
            this.calcWeigth(element);
          });
          this.productFeatures = productFeatures;
          this.summaryFeature();
        })
        .finally(() => {
          this.$refs.bmanufacture.unBlock();
        });
    },
    loadInfoProduct() {
      if (!this.manufacture.product || !this.manufacture.productSpecify || !this.manufacture.color) return;
      this.$refs.bmanufacture.block();
      //, this.manufacture.productSpecify.id, this.manufacture.color.id
      productService
        .findListInfoOfProduct({
          productId: this.manufacture.product.id,
          productSpecifyName: this.manufacture.productSpecify.name,
          colorCode1: this.manufacture.colorCode1,
          unit: this.manufacture.unit,
          length: this.manufacture.length,
          reasonId: this.manufacture.reasonId
        })
        .then(res => {
          if (res.status && res.data.data && res.data.data.length > 0) {
            let products = res.data.data;
            this.info = res.data.data[0];

            for (let i = 0; i < products.length; i++) {
              const element = products[i];
              let productSpecify = element.productSpecify;
              if (productSpecify.id == this.manufacture.productSpecify.id) {
                this.info = element;
                break;
              }
            }
          }
        })
        .finally(() => {
          this.$refs.bmanufacture.unBlock();
        });
    },
    handelChoosePrice(price) {
      if (this.productQuotationSelect) this.productQuotationSelect.price = price;
    },
    calcWeigth(item) {
      //quantityInventory --> quantityInventoryForMet
      item.weight = Number(
        ((Number(this.manufacture.quantityInventory) * Number(this.manufacture.quota)) / 1000) *
          (Number(item.percentYarn) / 100)
      );
      item.total_weight = Number(item.weight + (item.weight * Number(item.percentLoss)) / 100);
      if (!item.tldh || item.tldh == 0 || item.tldh == '') {
        item.tldh = Number(item.total_weight) + (Number(item.total_weight) * (Number(item.percentLoss) / 4)) / 100;
      }
    },
    doSave() {
      let manufacture = Object.assign({}, this.manufacture);
      manufacture.customer = {
        id: this.manufacture.customer.id
      };
      manufacture.product = {
        id: this.manufacture.product.id
      };
      manufacture.order = {
        id: this.manufacture.order.id
      };
      manufacture.color = {
        id: this.manufacture.color.id
      };

      manufacture.productSpecify = {
        id: this.manufacture.productSpecify.id
      };
      manufacture.processJson = JSON.stringify(manufacture.process);

      let seft = this;
      let productFeatures = this.productFeatures.slice();
      productFeatures.forEach(element => {
        delete element.edit;
        if (!seft.$route.query.edit_id) {
          delete element.id;
        }
      });

      let productParameters = this.productParameters.slice();
      productParameters.forEach(element => {
        delete element.edit;
        if (!seft.$route.query.edit_id) {
          delete element.id;
        }
      });
      this.$refs.bmanufacture.block();
      manufactureService
        .create(manufacture, productFeatures, productParameters)
        .then(res => {
          this.$alertify.success(res.message, {
            duration: 4000
          });
          this.manufacture = res.data.manufacture;
          this.manufacture.process = JSON.parse(this.manufacture.processJson);

          this.manufacture.dateDelivery = new Date(res.data.manufacture.dateDelivery);
          this.productFeatures.forEach(element => {
            element.edit = false;
          });
          if (res.data.manufactureParameters) {
            this.productParameters = res.data.manufactureParameters;
          } else {
            this.productParameters = [];
          }
          this.$router.push({
            name: 'add-manufacture',
            query: {
              edit_id: this.manufacture.id
            }
          });
        })
        .finally(() => {
          this.$refs.bmanufacture.unBlock();
        });
    },
    doPrint() {
      this.validateManufacture()
        .then(() => {
          this.$refs.preview.visible = true;
          this.$refs.preview.setData(this.manufacture, this.productFeatures, this.productParameters);
        })
        .catch(() => {
          this.$alertify.error('Vui lòng hoàn thành các trường được khoanh đỏ', {
            duration: 4000
          });
        });
    },
    doBack() {
      var self = this;
      this.$swal({
        title: 'Bạn có chắc thực hiện thao tác này?',
        text: 'Những thao tác bạn vừa thực hiện sẽ không được lưu lại',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'OK',
        cancelButtonText: 'Không',
        reverseButtons: true
      }).then(function(result) {
        if (result.value) {
          self.$router.go(self.back);
        }
      });
    }
  },
  watch: {
    'manufacture.quantityInventory': function() {
      // this.$alertify.warning(
      //   "Nếu không phải MET vui lòng cập nhật trường quy đổi",
      //   {
      //     duration: 4000
      //   }
      // );
      this.productFeatures.forEach(element => {
        this.calcWeigth(element);
      });
      this.summaryFeature();
    },
    'manufacture.quantityInventoryForMet': function() {
      this.productFeatures.forEach(element => {
        this.calcWeigth(element);
      });
    },
    'manufacture.quota': function() {
      this.productFeatures.forEach(element => {
        this.calcWeigth(element);
      });
      this.summaryFeature();
    }
  }
};
</script>
<style lang="scss">
.ck-editor__editable {
  min-height: 150px;
}
#add-quotation {
  .soft-control {
    .b-table-sticky-header {
      height: 500px;
      max-height: 500px;
    }
  }
}
</style>
